import * as ViewModel from '@/core/presenter/viewModel';
import clsx from 'clsx';
import { useCallback } from 'react';

interface IProps {
  totalBalance: string;
  trxAddress: string;
  isSendingAsset: boolean;
  dbsBuyCount: string;
  dbsBuyCountKRW: string;
  onClickCopyBtn: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onClickResetBtn: () => void;
  onClickSendBtn: () => void;
  onClickViewType: (viewType: ViewModel.HomeViewType) => void;
}

const MyAssetsCard = ({
  totalBalance,
  trxAddress,
  isSendingAsset,
  dbsBuyCount,
  dbsBuyCountKRW,
  onClickCopyBtn,
  onClickResetBtn,
  onClickSendBtn,
  onClickViewType,
}: IProps): JSX.Element => {
  const handleClickCopyBtn = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      onClickCopyBtn(e as unknown as React.MouseEvent<HTMLButtonElement>);
    },
    [onClickCopyBtn],
  );

  return (
    <div className="asset-card">
      <div className="asset-header">
        <img src="./images/gdf-logo.png" alt="GDF" className="asset-logo-icon" />
        <h2 className="asset-title heading-4 font-bold">자산정보</h2>
        <button type="button" className="refresh-btn" onClick={onClickResetBtn}>
          <img src="./images/refresh-icon.png" alt="새로고침" className="refresh-icon" />
        </button>
      </div>

      <div className="asset-items">
        <div className="asset-item">
          <span className="asset-label card-text-base font-medium">총 보유자산</span>
          <span className="asset-value text-lg font-bold">{totalBalance} KRW</span>
        </div>
        <div className="asset-item">
          <span className="asset-label card-text-base font-medium">구매수량</span>
          <span className="asset-value text-lg font-bold">{dbsBuyCount} GDF</span>
        </div>
        <div className="asset-item">
          <span className="asset-label card-text-base font-medium">구매금액</span>
          <span className="asset-value text-lg font-bold">{dbsBuyCountKRW} KRW</span>
        </div>
      </div>

      <div className="wallet-address">
        <span
          className="wallet-text text-sm font-normal"

        >
          {trxAddress}
        </span>
        <button type="button" className="copy-btn" onClick={handleClickCopyBtn}>
          <img src="./images/copy-icon.png" alt="복사" className="copy-icon" />
        </button>
      </div>

      <div className="asset-buttons">
        <button
          type="button"
          className={clsx('text-base font-semibold', isSendingAsset && 'asset-btn')}
          disabled={!isSendingAsset}
          id="sendBtn"
          onClick={onClickSendBtn}
        >
          보내기
        </button>
        <button
          type="button"
          className="asset-btn text-base font-semibold"
          id="receiveBtn"
          onClick={() => onClickViewType(ViewModel.HomeViewType.RECEIVE)}
        >
          받기
        </button>
      </div>
    </div>
  );
};

export default MyAssetsCard;
